import type { ContentPage } from "@/lib/content/types";

// MIGRATED page (Phase 3 step 3). Faithful port of the former hand-coded
// app/(homes)/(hrms)/hrms-software/attendance-management-system/
// geofencing-attendance/page.jsx onto the content engine (template
// "hrmsFeature"). Copy, images, links and heading levels match the original.
//
// SEO (title/description/canonical/OG/FAQ schema) is unchanged: it still comes
// from GeneralPageSEOMetadata.json via <SEO> (its "geofencing-attendance" entry
// is kept). The `seo` block below is an accurate fallback only. The FAQ
// accordion + body FAQ come from the same fetchMetadata("geofencing-attendance").

export const geofencingAttendance: ContentPage = {
  slug: "attendance-management-system/geofencing-attendance",
  template: "hrmsFeature",
  seo: {
    title: "Secure Geofencing for Accurate Attendance Tracking",
    description:
      "Use geofencing for accurate, secure attendance tracking with customizable boundaries and real-time monitoring, ideal for diverse workforce needs.",
    keywords: [
      "geofencing attendance",
      "location-based attendance",
      "secure clock-in",
      "workforce tracking",
      "remote attendance management",
    ],
    ogImage: "/assets/data/seoimages/geofencing-attendance.webp",
  },
  leaf: {
    hero: {
      caption: "Geofencing Attendance",
      title: "Enhance Security with Geofencing Attendance",
      description:
        "Utilize geofencing technology to manage employee attendance more securely and accurately, ideal for remote or on-site tracking.",
      h1: "caption",
    },
    split: {
      title: "Secure and Precise Location-Based Attendance",
      bullets: [
        {
          title: "Location-Based Clock-Ins",
          description: "Restrict clock-ins to designated geographical areas.",
        },
        {
          title: "Customizable Geofences",
          description:
            "Set up geofences for different job sites based on requirements.",
        },
        {
          title: "Real-Time Monitoring",
          description:
            "Track employee movements within the geofence with alerts.",
        },
        {
          title: "Secure Data Encryption",
          description:
            "Protect location data with advanced encryption for privacy.",
        },
      ],
      image:
        "/assets/images/img/product/hrms/attendancems/geofencing-attendance.webp",
      imageAlt: "geofencing-attendance",
    },
    cardsHeading: {
      title: "Key Features of Attendance Management System",
      description:
        "Optimize Attendance management with advanced features designed to streamline tracking, automation, and customization.",
    },
    cards: [
      {
        title: "Absence Management",
        href: "/hrms-software/attendance-management-system/absence-management",
        description:
          "Efficiently manage and track employee absences and leaves with our comprehensive absence management system, reducing disruptions and ensuring compliance.",
        image:
          "/assets/images/img/product/hrms/attendancems/absence-management_key_features.webp",
        imageAlt: "absence-management_key_features",
      },
      {
        title: "Real-Time Attendance Tracking",
        href: "/hrms-software/attendance-management-system/real-time-attendance-tracking",
        description:
          "Capture accurate employee attendance data in real-time, streamlining payroll processes and enhancing workforce management.",
        image:
          "/assets/images/img/product/hrms/attendancems/real_time-attendance_tracking_key_features.webp",
        imageAlt: "real_time-attendance_tracking_key_features",
      },
      {
        title: "Overtime Monitoring",
        href: "/hrms-software/attendance-management-system/overtime-monitoring",
        description:
          "Ensure fair compensation and compliance with our sophisticated overtime monitoring system, reducing discrepancies and boosting morale.",
        image:
          "/assets/images/img/product/hrms/attendancems/overtime-monitoring_key_features.webp",
        imageAlt: "overtime-monitoring_key_features",
      },
      {
        title: "Shift Management",
        href: "/hrms-software/attendance-management-system/shift-management",
        description:
          "Manage and automate employee shifts efficiently to ensure coverage and reduce scheduling conflicts with our advanced shift management tools.",
        image:
          "/assets/images/img/product/hrms/attendancems/shift_management_key_features.webp",
        imageAlt: "shift_management_key_features",
      },
    ],
    testimonials: {
      title: "200+ Businesses across India love & trust us!",
      description: "Know why Superworks is the best HR software in India",
    },
    bookDemoTitle: "Secure Your Workforce Attendance with Geofencing!",
    relatedBlogsKeyword:
      "hrms-leave-and-absence-management,hrms-geofencing-attendance,hrms-comprehensive-reporting",
    metaKey: "geofencing-attendance",
  },
  sections: [],
};
